import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import { INLINES, BLOCKS } from '@contentful/rich-text-types'

import type { Document } from '@contentful/rich-text-types'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import RichText from '@segment/matcha/recipes/RichText'

import bugBountyPng2x from './assets/BugBounty@2x.png'
import bugBountyWebp from './assets/BugBounty.webp'
import bugBountyWebp2x from './assets/BugBounty@2x.webp'
import bugBountyWebp3x from './assets/BugBounty@3x.webp'

const copy = {
  heading: `Bug bounty program`,
  description: `Happy Hunting!`,
}

const richTextDescription = {
  content: [
    {
      content: [
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `Since August of 2017, Segment has run a bug bounty program on the Bugcrowd platform. This program has provided tremendous value, and has improved security for both Segment and our customers. We consider our bug bounty program one of the best investments for finding and fixing existing vulnerabilities in our applications and internet-facing assets. We’ve also built productive relationships with security researchers and see some as an extension of our team. If you’ve found a vulnerability, please `,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `read the rules of our bounty brief and submit here`,
            },
          ],
          data: {
            uri: `https://bugcrowd.com/twilio`,
            target: `_blank`,
          },
          nodeType: INLINES.HYPERLINK,
        },
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `.`,
        },
      ],
      data: {},
      nodeType: BLOCKS.PARAGRAPH,
    },
  ],
  data: {},
  nodeType: BLOCKS.DOCUMENT,
} as Document

const BugBountyProgram: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <SectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading>{copy.heading}</CopyText.Heading>
            <CopyText.Description>
              <RichText data={richTextDescription} />
            </CopyText.Description>
            <CopyText.Description>{copy.description}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <SectionContents>
          <picture>
            <source type="image/webp" srcSet={`${bugBountyWebp}, ${bugBountyWebp2x} 2x, ${bugBountyWebp3x} 3x`} />
            <Image width="192" height="36" src={bugBountyPng2x} alt="Internal Security" loading="lazy" />
          </picture>
        </SectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const SectionContents = styled(Section.Contents)`
  display: flex;
  justify-content: center;
`

export default BugBountyProgram
